import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const actionDrawerDescription = style({
  color: themeVars.container.foreground.secondary,
});

export const modalContent = style({
  maxWidth: 405,
});

export const modalTitle = style({
  marginBottom: space.s10,
  textAlign: 'center',
});

export const modalDescription = style([
  actionDrawerDescription,
  typography.bodyMd,
  {
    textAlign: 'center',
  },
]);

export const authButtonsBox = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: space.s12,
  marginTop: space.s28,
});
